






























































import {Component, Prop, Vue} from 'vue-property-decorator';
import pmoduleStoreModule from '@/store/modules/entities/pmodules/pmoduleModule';
import enumsModule from '@/store/modules/enumsModule';
import {httpClient} from '@/api/baseApi';
import {EventDefaultValues} from '@/views/system/measurements/interfaces';
import DeleteDialog from '@c/DeleteDialog.vue';
import {Condition} from '../interfaces';
import {PModule} from '@/views/system/modules/interfaces';

@Component({
  components: {DeleteDialog},
})
export default class ConditionForm extends Vue {
  @Prop({required: true}) setting!: Condition;
  @Prop({required: true}) treeID!: number;
  @Prop({required: true}) groupIndex!: number;
  @Prop({required: true}) settingIndex!: number;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';

  positiveNumberRule = (v: any) => v > 0 || 'Поле должно быть положительным числом';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';
  @Prop({required: true}) deleteConditionCallback!: Function;

  get conditionTypes() {
    return ['=', '>', '>=', '<', '<='];
  }

  // настройки выбранного модуля
  moduleDefaultValues: EventDefaultValues[] = [];

  /// представление всех экземпляров модулей
  get modulesNames() {
    this.moduleDefaultValues = [];
    return this.modules.map(x => ({
      type: x.type,
      guid: x.guid,
      name: x.name,
    }));
  }

  // все экземпляры модулей
  modules: PModule[] = [];

  async created() {
    await pmoduleStoreModule.fetchAll();
    this.modules = [...pmoduleStoreModule.all];
  }

  getParameterName(parameter: string) {
    return this.aliasTypeNames.find(x => x.type === parameter)?.description;
  }

  getEventTypeName(parameter: string) {
    return this.eventTypeNames?.find(x => x.type === parameter)?.description;
  }

  get eventTypeNames() {
    if (this.moduleDefaultValues.length === 0 && this.setting.module_id) {
      this.getDefaultValues();
    }
    return this.moduleDefaultValues
      ? this.moduleDefaultValues.map(v => ({description: v.description, type: v.type}))
      : null;
  }

  get aliasTypeNames() {
    const aliasTypes = this.moduleDefaultValues.filter(
      (v: any) => v.type === this.setting.message_type,
    );
    return aliasTypes.length > 0
      ? aliasTypes[0].fields.map(v => ({description: v.description, type: v.alias}))
      : [];
  }

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  deleteCondition() {
    this.deleteDialog.open(this.treeID, {
      deleteCallback: async () => {
        try {
          this.deleteConditionCallback(this.treeID, this.groupIndex, this.settingIndex);
          this.deleteDialog.close();
        } catch (e) {
          this.deleteDialog.error('Произошла ошибка');
        }
      },
    });
  }

  onEventTypeChange() {
    this.setting.field_name = '';
  }

  async onModuleTypeChange() {
    // очистка зависимых данных
    this.setting.message_type = '';
    this.setting.field_name = '';
    // получение дефолтных значений
    this.getDefaultValues();
  }

  async getDefaultValues() {
    if (!this.modules.length) await pmoduleStoreModule.fetchAll();
    const type = this.modules.filter(v => v.guid === this.setting.module_id);
    if (!type.length) return;
    const currentModuleType = enumsModule.moduleTypes.filter(v => v.value === type[0].type);
    const moduleParametersResponse: {data: any} = await httpClient.get(
      `${currentModuleType[0].url}/events/event_types`,
    );
    this.moduleDefaultValues = moduleParametersResponse.data;
  }
}
